import { CellProps } from 'react-table'
import { FormularioTipoAtendimentoList } from '../../core/_models'
import { PlainHeader, StackedCell, TableColumn } from '../../../../../../components'
import { TiposAtendimentoVinculosActionsCell } from './TiposAtendimentoVinculosActionsCell'
import { TFunction } from '_metronic/i18n/Metronici18n'

// O endpoint não ordena: cabeçalhos sem ordenação (como já era).
export const vinculosTiposAtendimentoColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<FormularioTipoAtendimentoList>> => [
  {
    Header: () => <PlainHeader>Tipo de atendimento</PlainHeader>,
    id: 'tipoAtendimento',
    Cell: ({ row }: CellProps<FormularioTipoAtendimentoList>) => (
      <StackedCell primary={row.original.tipoAtendimento} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('empresa.label')}</PlainHeader>,
    id: 'empresa.nome',
    Cell: ({ row }: CellProps<FormularioTipoAtendimentoList>) => (
      <StackedCell primary={row.original.empresa?.nomeFantasia} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.unidade')}</PlainHeader>,
    id: 'unidade.nome',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<FormularioTipoAtendimentoList>) => (
      <StackedCell primary={row.original.unidade?.nome} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '100px',
    align: 'end',
    Cell: ({ row }: CellProps<FormularioTipoAtendimentoList>) => (
      <TiposAtendimentoVinculosActionsCell vinculo={row.original} />
    ),
  },
]
